import React from 'react';
import { WizardItem } from '../../../Interfaces/Wizard.interface';
import InputField from '../../../../BaseModule/Components/Form/Components/InputField';
import AddressWhispererField from '../../../../BaseModule/Components/Form/Components/AddressWhispererField';
import { WizardItemType } from '../../../Enums/WizardItemType.enum';

interface Props {
	item: Extract<
		WizardItem,
		{ type: WizardItemType.TEXT_FIELD | WizardItemType.TEXT_FIELD_2 }
	>;
}

const WizardTextField: React.FC<Props> = ({ item }) => {
	const settings = item.settings as Record<string, unknown> | undefined;
	const addressLookup =
		(settings?.addressLookup as Record<string, unknown>) ??
		(settings?.address_lookup as Record<string, unknown>);
	const hasLookup =
		addressLookup &&
		(addressLookup.apiUrl ??
			addressLookup.api_url ??
			addressLookup.apiEndpoint ??
			addressLookup.api_endpoint);

	if (hasLookup) {
		return (
			<AddressWhispererField
				name={item.key}
				label={item.title}
				isRequired={item.settings?.required}
				addressLookup={addressLookup}
				isWrapped
			/>
		);
	}

	return (
		<InputField
			name={item.key}
			label={item.title}
			isRequired={item.settings?.required}
			suffix={item.settings?.suffix}
			prefix={item.settings.prefix}
			isWrapped
		/>
	);
};

export default WizardTextField;
